var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2.75H4.5C3.5335 2.75 2.75 3.5335 2.75 4.5V19.5C2.75 20.4665 3.5335 21.25 4.5 21.25H19.5C20.4665 21.25 21.25 20.4665 21.25 19.5V4.5C21.25 3.5335 20.4665 2.75 19.5 2.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5229 21H18.3223C19.0908 21 19.4749 21 19.6867 20.8181C19.8712 20.6596 19.9854 20.4173 19.9992 20.1551C20.015 19.8541 19.8019 19.491 19.3757 18.7651L16.9938 14.708C16.6416 14.1081 16.4655 13.8082 16.2435 13.7037C16.0494 13.6122 15.8314 13.6122 15.6373 13.7037C15.4153 13.8082 15.2393 14.1081 14.887 14.708L14.2982 15.711M17.5229 21L11.4427 11.0273C11.093 10.4537 10.9182 10.167 10.6998 10.0661C10.5087 9.97795 10.2949 9.97795 10.1038 10.0661C9.88545 10.167 9.71062 10.4537 9.36094 11.0273L4.65605 18.7442C4.21057 19.4749 3.98783 19.8403 4.00051 20.144C4.01155 20.4087 4.12487 20.6543 4.31018 20.8152C4.52297 21 4.91429 21 5.69693 21H17.5229Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImage);
export default __webpack_public_path__ + "static/media/header-image.ff3b264ec63f1c6fe694b0f3bbe13edb.svg";
export { ForwardRef as ReactComponent };